<template>
  <g>
    <path
      d="M3820.006,1916.785l5.241,8-5.241,8"
      transform="translate(3834.747 1937.284) rotate(-180)"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3"
    /><rect
      width="24"
      height="24"
      fill="none"
    />
  </g>
</template>
